const hardcodedSiteConfig = {
  favicon:
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSEGyeVpf1TYJ3iMapWFAaZlPy0mNnGUFDCYw&s",
  pageTitle: "Operium Media",
  companyLogo:
    "https://cdn.prod.website-files.com/5fe889a0020395696fd7a32d/5fe9d3d619c71c682f983eac_full-logo-horizontal-transparant.avif",
  containerTitle: "Status van bestelling",
  statusBarColor: "#f49e2e",
  backgroundColor: "#120f16",
  statusBarTextColor: "#ffffff",
  smallContainerTextColor: "#e2ddd5",
  smallContainerTitleColor: "#f49e2e",
  smallContainerBackgroundColor: "#171520",
};

export default hardcodedSiteConfig;
